import React, { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import {
  getWorkOrderList,
  deleteWorkOrder as deleteWorkOrderApi,
} from "../../api/workorders";
import LGModalCrud from "../../organisms/LGCrud/LGModalCrud";
import WorkOrderForm from "../../organisms/WorkOrders/WorkOrderForm.tsx";
import WorkOrderGanttChart from "../../organisms/WorkOrders/WorkOrderGanttChart";
import DashboardLayout from "../../layouts/DashboardLayout";
import { LGTabPanel } from "../../molecules/LGTabPanel";
import { useCompany } from "../../contexts/CompanyContext";
import { dateFormatter } from "../../services/valueFormatters";

const optionalDate = {
  valueFormatter: (value) => (value ? dateFormatter.valueFormatter(value) : ""),
};

const columns = [
  { field: "id", headerName: "ID", width: 80 },
  {
    field: "productionDate",
    headerName: "Fecha de producción",
    width: 160,
    ...optionalDate,
  },
  { field: "originalCode", headerName: "Clave Sistema Malena", width: 170 },
  { field: "clientName", headerName: "Cliente", width: 200 },
  { field: "name", headerName: "Nombre del trabajo", width: 220 },
  { field: "description", headerName: "Descripción", width: 240 },
  { field: "quantity", headerName: "Cantidad", width: 110, type: "number" },
  { field: "material", headerName: "Material", width: 150 },
  { field: "sequence", headerName: "Secuencia", width: 120 },
  { field: "requestedFrom", headerName: "Solicitado por", width: 160 },
  { field: "providerLegalName", headerName: "Proveedor", width: 200 },
  { field: "statusName", headerName: "Estatus", width: 140 },
  {
    field: "createdAt",
    headerName: "Creada",
    width: 110,
    ...optionalDate,
  },
];

const WorkOrderCrud = ({ companyId }) => {
  const props = {
    fetchFunction: () => getWorkOrderList({ companyId }),
    deleteFunction: (id) => deleteWorkOrderApi(id),
    columns,
    addModalData: {
      header: "Nueva Orden de Trabajo",
      body: <WorkOrderForm companyId={companyId} />,
    },
    editModalData: {
      header: "Editar Orden de Trabajo",
      body: <WorkOrderForm companyId={companyId} />,
    },
    actions: ["create", "update", "delete"],
  };

  return <LGModalCrud key={companyId} props={props} />;
};

export default function WorkOrderScreen() {
  const [activeTab, setActiveTab] = useState(0);
  const { selectedCompany } = useCompany();

  if (!selectedCompany) {
    return (
      <DashboardLayout>
        <Box p={4}>
          <Typography>Seleccione una compañía primero</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Box
        sx={{
          backgroundColor: "white",
          borderBottom: 1,
          borderColor: "divider",
          position: "fixed",
          zIndex: 99,
          width: "100%",
        }}
      >
        <Tabs value={activeTab} onChange={(_event, value) => setActiveTab(value)}>
          <Tab label={`Órdenes de trabajo ${selectedCompany.name}`} />
          <Tab label="Gantt" />
        </Tabs>
      </Box>

      <LGTabPanel value={activeTab} index={0}>
        <WorkOrderCrud companyId={selectedCompany.id} />
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={1}>
        <WorkOrderGanttChart companyId={selectedCompany.id} />
      </LGTabPanel>
    </DashboardLayout>
  );
}
